import { Button } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';

export interface ScheduleReportButtonProps {
  onClick: () => void;
}

/** The Schedule Report control of every page whose data can be sent as a report. */
export const ScheduleReportButton = ({ onClick }: ScheduleReportButtonProps) => (
  <Button
    onClick={onClick}
    startIcon={<EditNoteIcon />}
    sx={{ fontSize: '.8rem', textTransform: 'none' }}>
    Schedule Report
  </Button>
);
